import ssoImg1 from "./../../../../assets/images/Services.jpg"; // Adjust the path as necessary


function Vessel() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Vessel operations at sea {" "}
        <span className="text-orange-ef3e33 font-400">FISHING AND OTHER</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
          </div>
          {/* <div className="col-lg">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> <br /> */}
        <p className="mb-4">
          This portal is under construction!!!
        </p>
        {/* <p className="mb-4 font-18 font-900">
           MOSR compliance regime
          </p>
          <p className="mb-4">
            Management of the compliance regime for stevedoring operations falls within SAMSA’s OHS & Maritime Welfare Unit. The Unit comprise of specialists in the field of Occupational Health and Safety. The Unit execute its mandate through the following activities.
          </p> */}
          
        </div>      
        
      </div>
    </>
  );
}


export default Vessel